import { useEffect } from "react";
import Highcharts from "highcharts";
import arrowYAxis from "../../../assets/arrow-yaxis.svg";
import arrowXAxis from "../../../assets/arrow-xaxis.svg";
import "./index.scss";
// import { engineSpeedMile, engineSpeedLastTrip } from "../../../_mock/vehicle-usage-profile/engineSpeed";

export const LineGraphWithThreshold = (data) => {
  const { dataSolid, dataDotted, title, xLabel, yLabel } = data.data;
  useEffect(() => {
    renderChart(dataSolid, dataDotted, title, xLabel, yLabel);
  }, [dataSolid, dataDotted]);

  const renderChart = (dataSolid, dataDotted, title, xLabel, yLabel) => {
    Highcharts.chart(
      "container",
      {
        chart: {
          backgroundColor: "#FFF",
          spacing: [20, 20, 20, 20],
          height: 350,
          // borderColor: "#CECECE",
          borderRadius: 20,
          // borderWidth: 1,
        },
        title: {
          text: title,
          align: "center",
          verticalAlign: "bottom",
        },

        yAxis: {
          title: {
            text: `<div><img src='${arrowYAxis}'/><div>${yLabel}</div></div>`,
            style: {
              color: "#000000",
            },
            align: "high",
            useHTML: true,
          },
          gridLineColor: "#f2f2f2",
        },

        xAxis: {
          title: {
            text: `<div><div>${xLabel}</div><img src='${arrowXAxis}'/></div>`,
            style: {
              color: "#000000",
            },
            align: "high",
            useHTML: true,
          },

          tickInterval:
            title === "Weighing Factor W.r.t Violation change - Tire Rotaion" ||
            title ===
              "Weighing Factor W.r.t Violation - Diagnostics Based Maintenance"
              ? null
              : 500,
        },

        legend: {
          enabled: false,
        },
        tooltip: {
          backgroundColor: "#000",
          style: {
            color: "#FFFFFF",
            font: "12px Open Sans",
          },
        },
        credits: {
          enabled: false,
        },

        series: [
          {
            data: dataSolid,
            dashStyle: "Solid",
            color: "#446EB8",
          },
          {
            data: dataDotted,
            dashStyle: "ShortDash",
            color: "#446EB8",
          },
        ],
      },
      function (chart) {
        // on complete

        if (chart.series?.[0]?.data?.length < 1) {
          // check series is empty
          chart.renderer
            .text("No Data Available", 50, 125)
            .css({
              color: "#000000",
              fontSize: "16px",
            })
            .add();
        }
      }
    );
  };

  return (
    <figure className="highcharts-figure full-width">
      <div id="container" className="full-width"></div>
    </figure>
  );
};
